<template>
  <div class="ci-keyboard">
    <div
      v-for="key in keyboard"
      :key="key"
      class="ci-keyboard__key"
      :class="{
        'ci-keyboard__key--cancel': key === 'cancel',
      }"
      @click="$emit('key', key)"
    >
      <template v-if="key === 'del'">
        <img
          class="ci-keyboard__img"
          src="@/assets/img/intercom/backwards@3x.webp"
          alt=""
        >
      </template>
      <template v-else-if="key === 'cancel'">
        取消
      </template>
      <template v-else>
        {{ key }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NumberKeyboard',
  data () {
    return {
      keyboard: ['1', '2', '3', '4', '5', '6', '7', '8', '9', 'cancel', '0', 'del']
    }
  }
}
</script>

<style lang="scss" scoped>
.ci-keyboard {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-items: center;
  box-sizing: border-box;
  gap: 14px 0;
  max-width: 390px;
  align-self: center;

  &__key {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    font-size: map-get($fontSize,xxx-large);
    line-height: 1.25;
    color: #1f211f;
    cursor: pointer;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    transition: background-color 0.1s;

    &:active {
      background-color: #f3f3f3;
    }

    &--cancel {
      font-size: map-get($fontSize,medium);
      color: #666;
    }

    & img {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
